import { z } from "zod";

export const EXAM_SESSION_SNAPSHOT_VERSION = 1;

export const SchrijvenTurnSnapshotSchema = z.object({
  turnId: z.string(),
  variantId: z.string(),
  taskType: z.string(),
  userText: z.string(),
  scoreJson: z.string(),
  tutorParagraph: z.string(),
  band: z.enum(["pass", "warn", "fail"]),
  createdAt: z.string().datetime(),
});
export type SchrijvenTurnSnapshot = z.infer<typeof SchrijvenTurnSnapshotSchema>;

export const ExamSessionSnapshotSchema = z.object({
  version: z.literal(EXAM_SESSION_SNAPSHOT_VERSION),
  sessionId: z.string(),
  module: z.string(),
  userId: z.number().int(),
  startedAt: z.string().datetime(),
  finishedAt: z.string().datetime().nullable(),
  turns: z.array(SchrijvenTurnSnapshotSchema),
});
export type ExamSessionSnapshot = z.infer<typeof ExamSessionSnapshotSchema>;
